import { render, staticRenderFns } from "./ModalDeleteBahanPacking.vue?vue&type=template&id=51c31b32&"
import script from "./ModalDeleteBahanPacking.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteBahanPacking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports